var _style, _path, _text, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "root",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 93 93",
    style: {
      enableBackground: "new 0 0 93 93"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#525151;stroke-width:2;}\n\t.st1{fill:#ECC2C2;}\n\t.st2{font-family:'Lato-Regular';}\n\t.st3{font-size:18px;}\n\t.st4{fill:none;stroke:#ECC2C2;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.1,1h78.9c3.3,0,5.1,3.6,5.1,6.9v78c0,3.3-1.8,6-5.1,6H7.1c-2.4,0-5.1-2.7-5.1-6v-78C2,4.6,4.6,1,7.1,1z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 19.6172 77.95)",
    className: "st1 st2 st3"
  }, "MENU")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_00000071548149243851536550000008412835839025278338_"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 27.6,
    y1: 21.3,
    x2: 65.4,
    y2: 21.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 27.6,
    y1: 35.5,
    x2: 65.4,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 27.6,
    y1: 49.7,
    x2: 65.4,
    y2: 49.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.c401aa5a09e3bc07fa25fd45a97f2968.svg";
export { ForwardRef as ReactComponent };